<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-paste"></i>
        サーバ情報
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WEBCastle</a>
        </li>
        <li class="separator">
          <i class="fa fa-angle-right"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">サーバ</a>
        </li>
      </ul>
    </div>
    <vcl-facebook v-if="loading"></vcl-facebook>
    <b-card v-else class="animated fadeIn fadeOut">
      <template v-if="quick_setting_status">
        <RuleQuickSetup
          :now_policy="now_policy"
          @toggle="x => quick_setting_status = x"
          @save="x => save_policy_quick(x)"
        >
        </RuleQuickSetup>
      </template>
      <b-card v-if="server && !quick_setting_status" class="animated fadeIn fadeOut" style="position:sticky; top:100px; z-index:15;">
        <b-row style="height: 65px !important; vertical-align: middle; cursor: pointer;">
          <b-col class="float-left mobile_hide_icon">
            <img src="img/icons/conf_logo.png" alt="" class="icon_45" style="margin: 5px 10px;" @click="apply_modal = true">
            <div class="d-inline-block" style="width: fit-content;">
              <p style="position:absolute; top:-10px; font-size:1.9rem; font-weight: bold">WAF構成</p>
              <span style="position:absolute; top:40px;color:gray; font-weight:bold; font-size:1.2rem; ">ホストネーム : {{server.host}}</span>
            </div>
          </b-col>
          <b-col class="text-right font-weight-bold">
            <span v-if="is_require_save" class="font-weight-bold text-danger" style="position: absolute; top: -25px; right:75px;">
              * ポリシーの変更がある変更内容を確認し、保存する
            </span>

            <div class="d-inline-block text-center" :class="{ 'op-25' : server.lock || is_require_save_style }">
              <div class="custom-control custom-switch custom-switch-xl mb-2">
                  <input
                  :disabled="server.lock || is_require_save_style"
                    v-on:change="status_save($event, server.policy_json.status)"
                    v-model="server.policy_json.status"
                    type="checkbox"
                    class="custom-control-input"
                    id="customSwitch3">
                  <label class="custom-control-label" for="customSwitch3">
                  </label>
              </div>
              <p for="customSwitch3" style="font-size: 9pt; display:inline-block;">WAFエンジン</p>
              <label class="text-info d-inline-block" v-b-tooltip.hover title="ポリシーによる障害が発生した場合、ファイアウォールエンジンの使用可否を設定することができます。変更時に直ちに反映されます。" style="cursor: pointer;">
                <i class="fa fa-question-circle"></i>
              </label>
            </div>
            <div class="d-inline-block text-center" @click="quick_setting_status = true" :class="{ 'op-25' : server.lock || is_require_save_style }">
              <img src="img/icons/conf_quick.png" class="d-inline-block icon_45" alt="" @click="() => (server.lock || is_require_save_style) ? '' :  apply_modal = true">
              <p style="font-size: 9pt;">クイックガイド</p>
            </div>
            <div class="d-inline-block text-center" @click="modal_upload_policy = true" :class="{ 'op-25' : server.lock || is_require_save_style }">
              <img src="img/icons/conf_upload.png" class="d-inline-block icon_45" alt="" @click="() => (server.lock || is_require_save_style) ? '' :  apply_modal = true">
              <p style="font-size: 9pt;">ポリシーアップロード</p>
            </div>
            <div class="d-inline-block text-center" @click="download_policy" :class="{ 'op-25' : server.lock || is_require_save_style }">
              <img src="img/icons/conf_download.png" class="d-inline-block icon_45" alt="" @click="() => (server.lock || is_require_save_style) ? '' :  apply_modal = true">
              <p style="font-size: 9pt;">ポリシーダウンロード</p>
            </div>
            <div class="d-inline-block text-center" :class="{ 'op-25' : server.lock || is_require_save_style }">
              <img src="img/icons/conf_delete.png" class="d-inline-block icon_45" alt="" @click="() => (server.lock || is_require_save_style) ? '' : toggle.modal_del = true">
              <p style="font-size: 9pt;">削除</p>
            </div>
            <div  class="d-inline-block text-center" :class="{ 'op-25' : server.lock || is_require_save_style }">
              <img src="img/icons/conf_list.png" class="d-inline-block icon_45" alt="" @click="server.lock ? '' : list()">
              <p style="font-size: 9pt;">一覧</p>
            </div>
            <!-- TODO : 2022.08 버전에서 배포 -->
            <!-- <div class="d-inline-block text-center">
              <img src="img/share.png" class="d-inline-block icon_45" alt="" @click="apply_modal = true">
              <p style="font-size: 9pt;">他サーバーの適用</p>
            </div> -->
            <div class="d-inline-block text-center" :class="{ 'op-25' : server.lock }">
              <img src="img/icons/conf_save.png" class="d-inline-block icon_45" alt="" @click="rule_confirm = true">
              <p style="font-size: 9pt;">保存</p>
            </div>
          </b-col>
        </b-row>
      </b-card>
      <!-- 아래부터 해야 함 -->
      <b-card v-if="server && !quick_setting_status" style="border: none; box-shadow: none; margin: 0;" no-body>
        <b-card-body style="padding: 5px !important;">
        <b-row class="text-center">
          <b-col md="3">
            <b-card style="box-shadow: 2px 2px 5px darkgray; height: 650px !important;">
              <div style="height: 450px; width: 1px; border: 1px solid gray; margin: 0 auto; position: absolute; z-index:0; left:50%; transform:translateX(-50%); margin-top: 100px;">
              </div>
              <div style="font-size: 14pt; margin: 10px 0px; font-weight: bold;" class="text-left">
                サーバー情報
              </div>
              <img v-b-tooltip.hover :title="`現在ドメインを設定中です ${now_policy.domain} ドメインごとにポリシーを設定できます ドメインが設定されていない場合は、デフォルトのドメインが設定されます`" :src="info.is_online ? 'img/icons/host_on.png' : 'img/icons/host_off.png'" alt="" class="img-fluid" width="180" style="margin-bottom: 20px; position: relative;">
              <!-- 도메인 -->
              <div class="d-inline-block text-ccenter" style="z-index: 100; width:100%; margin: 15px 0px; border: 2px solid #2F5597; border-radius: 2px; height:80px;">
                <!-- left -->
                <div class=" mobile_hide" style="display: flex; justify-content: center; align-items: center; font-size: 0.9rem; font-weight: bold; box-sizing: border-box; float:left; width:40%; height:100%; background-color:#2F5597; color:white;">
                  <span style="">
                    ドメイン
                    <span class="text-info" v-b-tooltip.hover :title="`現在ドメインを設定中です ${now_policy.domain} ドメインごとにポリシーを設定できます ドメインが設定されていない場合は、デフォルトのドメインが設定されます`">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>

                <!-- right -->
                <div class="mobile_extra" style="width:60%; height:100%; float:right; background-color:white; position:relative;">
                  <b-form-select v-if="server.policy_json.domains" v-model="now_policy.domain" @change="change_domain($event, now_policy.id)" size="sm" style="text-align: center; font-size: 12pt; width: 70%; margin-top:20px;">
                    <option v-for="(item,index) in server.policy_json.domains" :key="index" :value="item.domain">{{item.domain}} </option>
                  </b-form-select>
                </div>
              </div>
              <!-- WAS -->
              <div class="d-inline-block text-ccenter" style="z-index: 100; width:100%; margin: 15px 0px; border: 2px solid #203864; border-radius: 2px; height:80px;">
                <!-- left -->
                <div class=" mobile_hide" style="display: flex; justify-content: center; align-items: center; font-size: 0.9rem; font-weight: bold; box-sizing: border-box; float:left; width:40%; height:100%; background-color:#203864; color:white;">
                  <span style="">
                    WAS
                  </span>
                </div>

                <!-- right -->
                <div class="mobile_extra" style="display: flex; justify-content: center; align-items: center; height: 100%; width:60%; float:right; padding: 10px 0px; background-color:white; position:relative;">
                  <img v-if="server.iwaf_type == 'iis'" src="img/logos/was_iis.png" alt="" class="logo_120">
                  <img v-if="server.iwaf_type == 'apache'" src="img/logos/was_apache.png" alt="" class="logo_120">
                  <img v-if="server.iwaf_type == 'nginx'" src="img/logos/was_nginx.png" alt="" class="logo_120">
                  <img v-if="server.iwaf_type == 'lsws'" src="img/logos/was_lsws.png" alt="" class="logo_120">
                  <img v-if="server.iwaf_type == 'jeus'" src="img/logos/was_jeus.png" alt="" class="logo_120">
                  <img v-if="server.iwaf_type == 'tomcat'" src="img/logos/was_tomcat.png" alt="" class="logo_120">
                </div>
              </div>
              <!-- OS -->
              <div class="d-inline-block text-ccenter" style="z-index: 100; width:100%; margin: 15px 0px; border: 2px solid #222A35; border-radius: 2px; height:80px;">
                <!-- left -->
                <div class="mobile_hide" style="display: flex; justify-content: center; align-items: center; font-size: 0.9rem; font-weight: bold; box-sizing: border-box; float:left; width:40%; height:100%; background-color:#222A35; color:white;">
                  <span style="">
                    OS
                  </span>
                </div>

                <!-- right -->
                <div class="mobile_extra" style="display: flex; justify-content: center; align-items: center; width:60%; float:right; padding: 10px 0px; height:100%; background-color:white; position:relative;">
                  <img v-if="server.os_type == 'linux'" src="img/logos/os_linux.png" alt="" class="logo_120">
                  <img v-else src="img/logos/os_windows.png" alt="" class="logo_120">
                </div>
              </div>
            </b-card>
          </b-col>

          <b-col class="text-left">
            <b-card style="box-shadow: 2px 2px 5px darkgray;" class="mobile_webcastle_card_height">
              <b-row class="text-left">
                <b-col>
                  <p class="h4 font-weight-bold">ネットワーク情報</p>
                </b-col>
                <b-col>
                  <p class="h4 font-weight-bold">WAF情報</p>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col md="6">
                  <b-row>
                    <b-col class="mobile_hide_col">
                      <label class="col-form-label">
                        パブリック
                      </label>
                    </b-col>
                    <b-col>
                      <label class="col-form-label float-right">
                        {{server.ip_addr_public}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="mobile_hide_col">
                      <label class="col-form-label">
                        プライベート
                      </label>
                    </b-col>
                    <b-col>
                      <label class="col-form-label float-right">
                        {{server.ip_addr_private}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="mobile_hide_col">
                      <label class="col-form-label">
                        名前
                        <span class="text-info" v-b-tooltip.hover title="サーバーのホスト名とは異なる名前を付けることができます">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span>
                      </label>
                    </b-col>
                    <b-col>
                      <span class="col-form-label float-right">
                        <b-link href="javascript:void(0)" @click="name_modify_modal = true">
                          {{server.nickname | truncate(15) }}
                        </b-link>
                      </span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="mobile_hide_col">
                      <label class="col-form-label">
                          HA
                          <span @click="modal_duplex = true" class="text-info" v-b-tooltip.hover title="クリックして、サポート可能な冗長範囲を確認できます。">
                            <i style="cursor:pointer" class="fas fa-question-circle"></i>
                          </span>
                      </label>
                    </b-col>
                    <b-col>
                      <label class="col-form-label float-right">
                        <small>
                          準備中
                        </small>
                      </label>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col style="border-left: 1px solid silver;">
                  <b-row>
                    <b-col class="mobile_hide_col">
                      <label class="col-form-label">
                        <!-- <Bell :size="16" :count="1" v-if="is_available_mmdb_update" style="position: absolute; left:50px;" /> -->
                        WAF
                      </label>
                    </b-col>
                    <b-col>
                      <label class="col-form-label float-right">
                        {{server.version}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="mobile_hide_col">
                      <label class="col-form-label">
                        <Bell :size="16" :count="1" v-if="is_available_mmdb_update" style="position: absolute; left:60px;" />
                        GEO
                        <span style="margin-left: 40px;" v-if="is_available_mmdb_update && webcastle_mmdb"> v{{ webcastle_mmdb }}</span>
                      </label>
                    </b-col>
                    <b-col>
                      <label :class="(is_available_mmdb_update ? 'text-weight-bold col-form-label text-danger float-right' : 'col-form-label float-right')">
                        v{{server.mmdb_version}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="mobile_hide_col">
                      <label class="col-form-label">
                        <Bell style="position: absolute; left:60px;" :size="16" :count="crs_rule_count" v-if="latest_policy_version" />
                        ポリシー
                        <b-link href="javascript:void(0)" @click="upgrade_policy_modal = true" v-if="latest_policy_version">
                          <span style="margin-left: 40px;" v-if="is_available_mmdb_update && latest_policy_version">
                            v{{ latest_policy_version }}
                          </span>
                        </b-link>
                      </label>
                    </b-col>
                    <b-col>
                      <label :class="(latest_policy_version ? 'col-form-label text-weight-bold text-danger float-right' : 'col-form-label float-right')">
                        {{crs_rule.version}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="mobile_hide_col">
                      <label class="col-form-label">
                        ポリシータイプ
                        <span class="text-info" v-b-tooltip.hover title="ポリシーの分類を表示します。テストジョンチェ、ホスティング会社ポリシー、基本ポリシーなどが提供される場合があります。">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span>
                      </label>
                    </b-col>
                    <b-col>
                      <label class="col-form-label float-right">
                        <small>
                          準備中
                        </small>
                      </label>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card>
            <b-card style="box-shadow: 2px 2px 5px darkgray;" class="mobile_webcastle_card_height_domain">
              <b-row>
                <b-col class="text-center">
                  <p class="text-left" style="font-size: 1.2rem; font-weight: bold; margin: 0;">
                    <span v-if="is_changed('domain')" style="width: 10px; height:10px; background-color:red; border-radius:10px; position:absolute; left:0px;"></span>
                    ドメイン設定
                    <span class="text-info" v-b-tooltip.hover title="特定のドメインにポリシーを設定できます">
                      <i class="fas fa-question-circle"></i>
                    </span>
                  </p>
                  <p style="font-size: 3.2rem; font-weight: bold; margin:10px auto;">
                    {{server.policy_json.domains.length}}
                  </p>
                  <b-button size="sm" style="margin: 10px 5px;" variant="primary" @click="toggle.modal_domain_manage = true">ドメイン管理</b-button>
                  <p style="font-weight: bold; font-size: 0.8rem;">
                    * ドメインを設定しない場合
                    <br>
                    デフォルトのポリシーが反映されています
                  </p>
                </b-col>
                <b-col class="text-center" md="6" style="vertical-align: middle; border-left: 1px solid silver;">
                  <p class="text-left" style="font-size: 1.2rem; font-weight: bold; margin: 0;">
                    ルールモード比率
                    <span class="text-info" v-b-tooltip.hover title="未使用、検出、およびブロックされたポリシーの構成を表示します">
                      <i class="fas fa-question-circle"></i>
                    </span>
                  </p>
                  <VueApexCharts style="max-height:350px!important; margin: 0 auto;" :height="250" type="donut" ref="_chart_policy" :options="info.chart.policy.option" :series="info.chart.policy.series" />
                  <!-- TODO : 보안 레벨 부분은 향후 2023 출시 예정 -->
                  <!-- <span style="font-size: 18pt; font-weight: bold;">
                    보안 레벨
                    <span class="text-info" style="cursor: pointer;" @click="explain_level = true" v-b-tooltip.hover title="クリックすると説明文が表示されます">
                      <i class="fa fa-question-circle"></i>
                    </span>
                  </span>

                  <p class="mt-5">
                    <div v-for="item, index in codes.WAF_LEVEL" :key="'_level'+index" style="margin: 5px 10px; padding: 5px 15px; display: inline-block; width: 50px;">
                      <div>
                        <div @click="now_policy.level = item" :style="`width: 12px; height: 12px; border-radius: 50%; border: 12px solid ${item > now_policy.level ? 'silver' : '#5858ed'};position:absolute; `"></div>
                        <div :style="` width: 22px; height: 22px; border-radius: 50%; border: 20px solid #5858ed;position:relative; opacity:${item == now_policy.level ? '0.3' : '0'}; left: -8px; top: -8px;`"></div>
                      </div>

                      <div style="width: 100%; font-size: 22pt; font-weight: bold; margin-top: 15px; cursor: pointer;" @click="now_policy.level = item">
                        {{item}}
                      </div>
                    </div>
                  </p> -->

                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col class="wc_log_right">
            <LogList enable_paging="true" custom_title="Log" :only_view="true" :agent_id="server.id" :summary="true" :dc="true" @detail="x => { modal_log_id = x; toggle.modal_log = true }" custom_style="max-height: 650px !important;height: 650px !important; box-shadow: 2px 2px 5px darkgray;" show_count="10"/>
            <!-- TODO : 향후 레벨 개념이 있을 경우 차트 필요 -->
            <!-- <b-card style="box-shadow: 5px 5px 10px darkgray;">
              <BarChart v-if="summary.level.chart" :chartData="summary.level.chart" :options="{}" />
            </b-card> -->
          </b-col>


          <!-- 제어 -->
          <!-- <b-col>
            <div>
              <b-button block size="sm" class="btn-addition" variant="success" @click="rule_confirm = true">ポリシーを保存
              </b-button>
              <b-button block size="sm" class="mb-2" variant="warning" @click="apply_modal = true">他のサーバーにコピー</b-button>

              <b-button size="sm" v-if="server.is_alive" block @click="toggle.modal_del = true" variant="danger">削除する</b-button>
              <b-button class="mt-2" size="sm" block variant="light" @click="list()">一覧へ</b-button>
            </div>
          </b-col> -->
        </b-row>
        <b-row class="text-center wc_log_row mb-4">
          <b-col>
            <LogList enable_paging="true" custom_title="検出ログ" :only_view="true" :agent_id="server.id" :summary="true" :dc="true" @detail="x => { modal_log_id = x; toggle.modal_log = true }" custom_style="max-height: 650px !important;height: 650px !important; box-shadow: 2px 2px 5px darkgray;" show_count="10"/>
          </b-col>
        </b-row>
        <hr>
        <b-row class="text-center">
          <b-col>
            <b-button v-b-tooltip.hover title="エージェントがオンラインかどうかを確認できます" aria-controls="collapse-1" @click="toggle_resource" variant="primary" :disabled="!info.is_online" v-b-toggle.collapse-3 class="m-1" style="position: relative; top: -38px; margin:auto 0px;">
              システムリソースの監視
            </b-button>
          </b-col>
        </b-row>
        <!-- 아래 차트 -->
        <b-collapse v-model="toggle.chart" id="collapse-1">
          <vcl-facebook v-if="!info.chart.memory.series.length" class="mb-4"></vcl-facebook>
          <b-row class="text-center" v-else>
            <!-- 메모리 차트 영역 -->
            <b-col class="animated fadeIn fadeOut" md="6">
              <b-row v-if="server.os_type != 'linux'">
                <b-col md="6">
                  <div v-if="info.chart.memory.series && info.chart.memory.series.length > 0">
                    <VueApexCharts type="area" height="150" ref="_chart_memory" :options="info.chart.memory" :series="info.chart.memory.series" />
                  </div>
                </b-col>
                <b-col md="6">
                  <div v-if="info.chart.memory.series && info.chart.memory.series.length > 0">
                    <VueApexCharts type="area" height="150" ref="_chart_cpu" :options="info.chart.cpu" :series="info.chart.cpu.series" />
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="server.os_type == 'linux'">
                <b-col>
                  <div v-if="info.chart.memory.series && info.chart.memory.series.length > 0">
                    <VueApexCharts type="area" height="150" ref="_chart_memory" :options="info.chart.memory" :series="info.chart.memory.series" />
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="server.os_type == 'linux'">
                <b-col>
                  <div v-if="info.chart.memory.series && info.chart.memory.series.length > 0">
                    <VueApexCharts type="area" height="150" ref="_chart_cpu" :options="info.chart.cpu" :series="info.chart.cpu.series" />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div v-if="info.status.system_cpu_info && info.status.system_cpu_info.usages && info.status.system_cpu_info.usages.length > 0">
                    <VueApexCharts type="heatmap" height="140" ref="_chart_workload" :options="info.chart.workload" :series="info.chart.workload.series" />
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col v-if="info.is_online" class="rounded-lg pt-2 m-2 text-left animated fadeIn fadeOut">
              <folderSet :disk_list="disckStatus" />
            </b-col>
          </b-row>
        </b-collapse>
      </b-card-body>
      </b-card>
      <b-row v-if="!quick_setting_status" style="position:sticky; top:232px; z-index:15;">
        <b-col md="12">
          <b-input-group class="text-center">
            <span style="font-size:25px; position: absolute; top: 10px; margin-left: 15px; z-index: 20; color: #4f5b66;"><i class="fa fa-search"></i></span>
            <input style="box-shadow: 3px 3px 5px 1px gray; border-radius: 25px !important; font-weight:bold; font-size:26px !important;" class="form-control bg_gray" type="search" :value="search_key" @input="x => search_key = x.target.value" placeholder="Enter policy number or detection message">
          </b-input-group>
        </b-col>
      </b-row>

      <b-row class="text-center mt-4" v-if="server && !quick_setting_status && is_available_policy_request">
        <b-col class="text-left float-left">
          <p class="h4 font-weight-bold d-inline-block">リクエストポリシー</p>
          <label class="d-inline-block float-right">
            <b-form-checkbox
            :checked="crs_count_preview"
            class="d-inline-block ml-4"
            name="check-button"
            switch
            @change="toggle_crs_count_preview"
          ></b-form-checkbox>
          概要情報を表示
            <span class="text-info" v-b-tooltip.hover title="ポリシー内の未使用、検出、およびブロックされたポリシーの数を表示します。">
              <i style="cursor:pointer" class="fas fa-question-circle"></i>
            </span>
          </label>
          <div style="width: 100%; height:40px;">
            <p class="h6 d-inline-block" style="padding-right:15px; position:relative; z-index:10; height: 20px; background-color:white">マウスオーバーすると攻撃の説明が表示</p>
            <p class="d-inline-block mx-auto" style="height: 2px; background-color:gray; width:100%; position:relative; top:-22px;"></p>
            <!-- <div style="height: 2px; background-color:gray; width: 100%; position:absolute; top:42px;"></div> -->
          </div>
              <RuleCRS
                v-for="(item, index) in base_policy.request" v-bind:key="index + '_request'"
                v-if="item.i18n && item.is_available"
                :base_crs="item"
                :custom_crs="now_policy.custom_crs_dic[item.key]"
                :search="search_key"
                :summary="summary"
                :crs_count_preview="crs_count_preview"

                @save="save_policy_one"
              />
            </b-col>
          </b-row>

          <b-row class="text-center mt-4" v-if="server && !quick_setting_status">
            <b-col class="text-left float-left">
              <p class="h4 font-weight-bold">処理ポリシー</p>
              <div style="width: 100%; height:40px;">
                <p class="h6 d-inline-block" style="padding-right:15px; position:relative; z-index:10; height: 20px; background-color:white">マウスオーバーすると攻撃の説明が表示</p>
                <p class="d-inline-block mx-auto" style="height: 2px; background-color:gray; width:100%; position:relative; top:-22px;"></p>
                <!-- <div style="height: 2px; background-color:gray; width: 100%; position:absolute; top:42px;"></div> -->
              </div>
              <RuleCRS
                  v-for="(item, index) in base_policy.process" v-bind:key="index + '_request'"
                  v-if="item.i18n && item.is_available"
                  :base_crs="item"
                  :custom_crs="now_policy.custom_crs_dic[item.key]"
                  :search="search_key"
                  :summary="summary"
                  :crs_count_preview="crs_count_preview"

                  @save="save_policy_one"
                />

            </b-col>
          </b-row>

          <b-row class="text-center mt-4" v-if="server && !quick_setting_status && is_available_policy_response">
            <b-col class="text-left float-left">
              <p class="h4 font-weight-bold">レスポンスポリシー</p>
              <div style="width: 100%; height:40px;">
                <p class="h6 d-inline-block" style="padding-right:15px; position:relative; z-index:10; height: 20px; background-color:white">マウスオーバーすると攻撃の説明が表示</p>
                <p class="d-inline-block mx-auto" style="height: 2px; background-color:gray; width:100%; position:relative; top:-22px;"></p>
                <!-- <div style="height: 2px; background-color:gray; width: 100%; position:absolute; top:42px;"></div> -->
              </div>
              <RuleCRS
                v-for="(item, index) in base_policy.response" v-bind:key="index + '_request'"
                v-if="item.i18n && item.is_available"
                :base_crs="item"
                :custom_crs="now_policy.custom_crs_dic[item.key]"
                :search="search_key"
                :summary="summary"
                :crs_count_preview="crs_count_preview"

                @save="save_policy_one"
              />
        </b-col>
      </b-row>
      <b-row class="text-center mt-4" v-if="server && !quick_setting_status && is_available_policy_exclusion">
        <b-col class="text-left float-left">
          <p class="h4 font-weight-bold d-inline-block">排他的ポリシー</p>
          <span class="text-info" v-b-tooltip.hover title="サービスの可用性のために使用されているサービスの除外ポリシーを提供します">
            <i style="cursor:pointer" class="fas fa-question-circle"></i>
          </span>
          <div style="width: 100%; height:40px;">
            <p class="h6 d-inline-block" style="padding-right:15px; position:relative; z-index:10; height: 20px; background-color:white">マウスオーバーすると攻撃の説明が表示</p>
            <p class="d-inline-block mx-auto" style="height: 2px; background-color:gray; width:100%; position:relative; top:-22px;"></p>
          </div>
          <RuleCRS
              v-for="(item, index) in base_policy.exclusion" v-bind:key="index + '_request'"
              v-if="item.i18n && item.is_available"

              :base_crs="item"
              :custom_crs="now_policy.custom_crs_dic[item.key]"
              :search="search_key"
              :summary="summary"
              :crs_count_preview="crs_count_preview"

              @save="save_policy_one"
            />
        </b-col>
      </b-row>
    </b-card>

    <div class="d-flex flex-wrap align-items-center" v-if="server && !quick_setting_status && !loading">
      <div class="title mx-auto">
        その他のポリシー
        <button type="button" class="btn btn-sm btn-secondary ml-2" data-toggle="collapse" data-target="#more_option" id="Collapse-01">
          <span id="Collapse_text-01">表示</span>
          <span><i class="fas fa-plus-circle" id="Collapse_icon-01"></i></span>
        </button>
      </div>
      <span v-if="is_require_save" class="font-weight-bold text-danger" style="position:absolute;">
        * ポリシーの変更がある 変更内容を確認し、保存する
      </span>
    </div>

    <!-- 아래부터 옵션 설정 -->
    <hr v-if="!loading">

    <b-row id="more_option" class="collapse pb-5" style="margin-bottom: 4.0rem !important;">
      <b-col>
        <!-- 탭부분 시작 -->
        <b-tabs v-if="server && !quick_setting_status && !loading" class="animated fadeIn fadeOut" v-model="tab_index">
          <!-- ip 관련 접근 제어 -->
          <b-tab style="cursor: pointer;">
            <template #title>
              IP & ドメインポリシー
              <div v-if="is_changed('ip_list') || is_changed('host_list')" style="width: 10px; height:10px; background-color:red; border-radius:10px; float:right; margin-left:5px;"></div>
            </template>
            <b-row>
              <b-col>
                <RuleCustom
                  valid="ip"
                  class="animated fadeIn fadeOut"
                  title="IPアドレスポリシー"
                  description="Add Policy IP Address (ex, '222.222.222.222)"
                  tooltip="Set a specific IP request separately ex) If 1.1.1.1, all IPs approaching 1.1.1.1 will be blocked"
                  :policy_list="now_policy.ip_list"

                  @update="(val) => { now_policy.ip_list = val; check_change(); }"
                />
              </b-col>
              <b-col>
                <RuleCustom
                  valid="domain"
                  :is_preview="now_policy.domain != 'default'"
                  class="animated fadeIn fadeOut"
                  title="ドメインポリシー"
                  description="デフォルトのポリシーで管理するドメイン (例: 「google.com」) を追加します"
                  tooltip="ポリシーはデフォルト ポリシーでのみ構成可能で、ポリシー内のクライアントのリクエストのヘッダーのホスト フィールドに基づいて識別されます。 特定のドメインを検出またはブロックするように設定します。 例) google.com を設定するときに google.com をブロックまたは検出します。"
                  :policy_list="now_policy.host_list"

                  @update="(val) => { now_policy.host_list = val; check_change(); }"
                />
              </b-col>
            </b-row>

          </b-tab>
          <!-- CUSTOM country code -->
          <b-tab style="cursor: pointer;">
            <template #title>
              Geo(国)ポリシー
              <div v-if="is_changed('country_code') || is_changed('use_geoip')" style="width: 10px; height:10px; background-color:red; border-radius:10px; float:right; margin-left:5px;"></div>
            </template>
            <RuleCountry
              v-if="server.id"

              class="animated fadeIn fadeOut"
              tooltip="Web リクエスト クライアントの承認済み IP を国ごとに特定します。国をクリックして、検出またはブロックに設定できます。不要な国へのアクセスはブロックすることをお勧めします。"
              :agent_id="server.id"
              :use_geoip="now_policy.use_geoip"
              :policy_list="now_policy.country_code"
              gchart_id="_gchart_agent_en"

              @update="(val) => { now_policy.country_code = val; check_change(); }"
              @update_toggle="(val) => { now_policy.use_geoip = val; check_change(); }"

            />
          </b-tab>
          <!-- 사용자 옵션 -->
          <b-tab style="cursor: pointer;">
            <template #title>
              パス / パラメータ
              <div v-if="is_changed('path') || is_changed('parameter')" style="width: 10px; height:10px; background-color:red; border-radius:10px; float:right; margin-left:5px;"></div>
            </template>
            <b-row>
              <b-col>
                <!-- path 관련 사용자 정책 설정 -->
                <RuleCustom
                  class="animated fadeIn fadeOut"
                  title="パスポリシー"
                  description="管理するパスを追加します (例: '/root')"
                  tooltip="特定のパスを使用して別のリクエストを設定します。 例) http://f1security.co.kr/manager/index.html の /manager パスをブロックすると、index.html ページも設定に従って実行されます"
                  :policy_list="now_policy.path"

                  @update="(val) => { now_policy.path = val; check_change(); }"
                />
              </b-col>
              <b-col>
                <!-- parameter 관련 사용자 정책 설정 -->
                <RuleCustom
                  class="animated fadeIn fadeOut"
                  title="パラメータポリシー"
                  description="管理するパラメータを追加します (例: 'id=password')"
                  tooltip="特定のパラメータを使用して別のリクエストを設定する 例) kyword=password の例のようにパスワード パラメータをブロックすると、例のようなパスワードのパラメータを含む Web リクエストが設定に従って実行されます。"
                  :policy_list="now_policy.parameter"

                  @update="(val) => { now_policy.parameter = val; check_change(); }"
                />
              </b-col>
            </b-row>
          </b-tab>
          <!-- custom 문법 체크가 필요함 -->
          <b-tab style="cursor: pointer;" title="ユーザーポリシー(CRS) / リダイレクト">
            <template #title>
              ユーザーポリシー(CRS) / リダイレクトポリシー
              <div v-if="is_changed('redirection') || is_changed('custom_policy')" style="width: 10px; height:10px; background-color:red; border-radius:10px; float:right; margin-left:5px;"></div>
            </template>
            <b-row>
              <b-col>
                <strong>
                  <b-badge variant="warning">お知らせ</b-badge> : 専門家のみ推奨
                  <span class="text-info" v-b-tooltip.hover title="カスタム CRS ポリシーは、CRS 文法に従って作成する必要があります。 ルールIDを指定 6000000-+ ID">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </strong>
                <p class="mt-4">
                  例 「IPアドレスにホストヘッダが要求された場合」検出されたルールは920350です
                  <br>
                  例）SecRuleUpdateActionById 920350 "t:none,msg:'ネットワーク攻撃',許可"
                </p>

                <b-form-group>
                  <b-form-textarea @change="check_change" id="ph_content" v-model="custom_policy" :rows="crs_line_count()" :max-rows="80"></b-form-textarea>
                </b-form-group>
              </b-col>
              <b-col>
                <strong>
                  <p>
                    リダイレクション
                  </p>
                  検知攻撃時のリダイレクトを設定。本設定は追加機能です。
                  <span class="text-info" v-b-tooltip.hover title="攻撃が識別された場合 (ポリシーによって検出された場合)、ページを指定された URL にリダイレクトします。設定されていない場合、403 HTTP は未承認として応答されます。">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </strong>

                <hr>
                <p>
                  <b-badge pill variant="primary">次期バージョンの機能予約</b-badge>
                  <!-- <b-button variant="link" @click="() => { now_policy.redirection = get_url(); check_change(); }">
                    Ex) {{ get_url() }}
                  </b-button> -->
                  <small v-if="is_changed('redirection')" class="float-right text-danger font-weight-bold">* セーブを要求</small>
                </p>

                <b-form-input :disabled="true" @change="check_change" :state="Boolean(now_policy.redirection)" placeholder="リダイレクト URL を入力してください" class="m-2" size="xl" v-model="now_policy.redirection"></b-form-input>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab style="cursor: pointer;">
            <template #title>
              リソース監視
              <div v-if="is_changed('agent.setting')" style="width: 10px; height:10px; background-color:red; border-radius:10px; float:right; margin-left:5px;"></div>
            </template>
            <b-row>
              <b-col class="text-center">
                <p style="display:inline-block; cursor: pointer;" @click="() => { agent_setting.limit_mode = !agent_setting.limit_mode; check_change(); }">
                  <span class="mr-3">リソース監視アラート設定</span>
                  <i v-if="agent_setting.limit_mode" class="fa fa-refresh fa-spin"></i>
                  </p>
                <c-switch @change="check_change" class="float-right" color="success" label variant="pill" v-model="agent_setting.limit_mode" />
                <br>
                <small class="text-danger">システムリソースがしきい値を超えた場合、最初の通知が発行され、通常時に通知を再通知できます。 しきい値は90%、通常の基準は60%</small>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col sm="2" class="mt-2">CPUリミット(%)</b-col>
              <b-col sm="2">
                <b-input-group class="mt-1 mb-1">
                  <b-form-input min="0" max="100" v-on:input="check_change()" :disabled="!agent_setting.limit_mode" :number="true" type="number" placeholder="90" v-model="agent_setting.limit_cpu"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="2" class="mt-2">RAMリミット(%)</b-col>
              <b-col sm="2">
                <b-input-group class="mt-1 mb-1">
                  <b-form-input min="0" max="100" v-on:input="check_change()" :disabled="!agent_setting.limit_mode" :number="true" type="number" placeholder="90" v-model="agent_setting.limit_ram"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="2" class="mt-2">Diskリミット(%)</b-col>
              <b-col sm="2">
                <b-input-group class="mt-1 mb-1">
                  <b-form-input min="0" max="100" v-on:input="check_change()" :disabled="!agent_setting.limit_mode" :number="true" type="number" placeholder="90" v-model="agent_setting.limit_disk"></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row>
              <!-- 여기서 라인 나눔 -->
              <b-col sm="2" class="mt-2">CPUリカバー(%)</b-col>
              <b-col sm="2">
                <b-input-group class="mt-1 mb-1">
                  <b-form-input min="0" max="100" v-on:input="check_change()" :disabled="!agent_setting.limit_mode" :number="true" type="number" v-model="agent_setting.resolve_cpu">
                  </b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="2" class="mt-2">RAMリカバー(%)</b-col>
              <b-col sm="2">
                <b-input-group class="mt-1 mb-1">
                  <b-form-input min="0" max="100" v-on:input="check_change()" :disabled="!agent_setting.limit_mode" :number="true" type="number" v-model="agent_setting.resolve_ram">
                  </b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="2" class="mt-2">Diskリカバー(%)</b-col>
              <b-col sm="2">
                <b-input-group class="mt-1 mb-1">
                  <b-form-input min="0" max="100" v-on:input="check_change()" :disabled="!agent_setting.limit_mode" :number="true" type="number" v-model="agent_setting.resolve_disk">
                  </b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
          </b-tab>
          <!-- 기본 제한 값 변경 -->
          <b-tab style="cursor: pointer;" v-if="false">
            <template #title>
              リミットポリシー
              <div v-if="is_changed('limit')" style="width: 10px; height:10px; background-color:red; border-radius:10px; float:right; margin-left:5px;"></div>
            </template>
            <!-- 요청 -->
            <b-row class="text-center">
              <b-col sm="4" class="mt-2">
                <strong class="font-weight-bold">
                  リクエスト
                </strong>
              </b-col>
              <b-col sm="2" class="mt-2">
                <strong class="font-weight-bold">
                  リミットリクエストデータ（バイト） - ファイル転送
                  <span class="text-info" v-b-tooltip.hover title="クライアントが要求する本文データの制限を設定し、アップロードが広く利用されているサイトでは値を変更することを推奨します">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </strong>
              </b-col>
              <b-col sm="2">
                <b-input-group class="mt-1 mb-1">
                  <b-form-input @change="check_change" :number="true" type="number" v-model="now_policy.limit.request_body_limit"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="2" class="mt-2">
                <strong class="font-weight-bold">
                  リミットリクエストデータ（バイト） - ファイル未送信
                  <span class="text-info" v-b-tooltip.hover title="ファイルを転送せずに application/x-ww-form-urlencoded に送信する場合、クライアントによって要求された本文データの制限を設定します">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </strong>
              </b-col>
              <b-col sm="2">
                <b-input-group class="mt-1 mb-1">
                  <b-form-input @change="check_change" :number="true" type="number" v-model="now_policy.limit.request_body_limit_no_file"></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>

            <!-- 응답 -->
            <b-row class="text-center">
              <b-col sm="4" class="mt-2">
                <strong class="font-weight-bold">
                  応答
                </strong>
              </b-col>

              <b-col sm="2" class="mt-2">
                <strong class="font-weight-bold">
                  リミット応答データ (Byte)
                  <span class="text-info" v-b-tooltip.hover title="クライアントのリクエストに対してWebサーバーが応答する際の最大データサイズを設定します。これを超えると応答しません。">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </strong>
              </b-col>
              <b-col sm="2">
                <b-input-group class="mt-1 mb-1">
                  <b-form-input @change="check_change" :number="true" type="number" v-model="now_policy.limit.response_body_limit"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="2" class="mt-2">
                <!-- <strong class="font-weight-bold">
                  要求データ制限(Byte) - ファイル未送信
                  <span class="text-info" v-b-tooltip.hover title="クライアントが要求するbodyデータの制限を設定します。ファイル転送せずに application/x-www-form-urlencoded に送信される場合に該当します">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </strong> -->
              </b-col>
              <b-col sm="2">
                <!-- <b-input-group class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="now_policy.limit.request_body_limit"></b-form-input>
                </b-input-group> -->
              </b-col>
            </b-row>

            <!-- 공용 -->
            <b-row class="text-center">
              <b-col sm="4" class="mt-2">
                <strong class="font-weight-bold">
                  コモン
                  <span class="text-info" v-b-tooltip.hover title="Web サーバーでサポートされる MIME のタイプを設定できます。デフォルトでは、text/plain、text/html、text/xml の 3 つだけが有効です。">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </strong>
              </b-col>
              <b-col class="text-center">
                <multiselect
                  v-model="now_policy.limit.mime_type"
                  tag-placeholder="選んでください"
                  placeholder="選んでください"
                  :options="codes.WAF_MIME_TYPE"
                  :multiple="true"
                  :taggable="false"
                  @input="check_change"
                >
                </multiselect>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab style="cursor: pointer;" :disabled="true">
            <template #title>
              APIポリシー（近日公開予定）
              <div v-if="is_changed('agent_setting')" style="width: 10px; height:10px; background-color:red; border-radius:10px; float:right; margin-left:5px;"></div>
            </template>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>

    <!-- 정책 저장 전 변경 확인 모달 -->
    <b-modal size="xl" title="ポリシーを適用しますか?" class="modal-warning" v-model="rule_confirm" @ok="save_policy_option" ok-variant="danger"
      header-bg-variant="danger">
      <b-row>
        <b-col>
          <p>
            変更されたポリシーを表示する
            <strong class="text-danger">
              ルールの設定が間違っていると、サービスに影響が出ることがあります。以下に変更を表示すると、ユーザーポリシーのみが表示されます。
            </strong>
          </p>
        </b-col>
      </b-row>

      <!-- 서버의 도메인 설정(전체적 설정) -->
      <!-- 도메인 관리 -->
      <b-row v-if="is_changed('domain')" class="mt-4 text-center">
        <b-col>
          <b-table v-if="get_unsaved_preview_domain()" striped hover small fixed class="table_add" :items="get_unsaved_preview_domain()" empty-text="not found">
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template slot="domain" slot-scope="row">
              {{row.item.domain}}
            </template>
            <template slot="type" slot-scope="row">
              {{row.item.type}}
            </template>
          </b-table>
        </b-col>
      </b-row>

      <!-- IP 주소, 도메인 예외 -->

      <!-- ip 관리 -->
      <b-row v-if="is_changed('ip_list')" class="mt-4 text-center">
        <b-col>
          <strong class="text-danger">Before</strong>
          <RuleCustom
            :is_preview="true"
            class="animated fadeIn fadeOut"
            title="IPアドレスポリシー"
            description="ポリシーIPアドレスの追加 (例, '222.222.222.222)"
            tooltip="特定のIPリクエストを別途設定します。 例) 1.1.1.1の場合、1.1.1.1に近づくすべてのIPがブロックされます"
            :policy_list="get_origin_policy('ip_list')"
          />
        </b-col>
        <b-col>
          <strong class="text-danger">Now</strong>
          <RuleCustom
            :is_preview="true"
            class="animated fadeIn fadeOut"
            title="IPアドレスポリシー"
            description="ポリシーIPアドレスの追加 (例, '222.222.222.222)"
            tooltip="特定のIPリクエストを別途設定します。 例) 1.1.1.1の場合、1.1.1.1に近づくすべてのIPがブロックされます"
            :policy_list="now_policy.ip_list"
          />
        </b-col>
      </b-row>

      <!-- 도메인 예외 관리 -->
      <b-row v-if="is_changed('host_list')" class="mt-4 text-center">
        <b-col>
          <strong class="text-danger">Before</strong>
          <RuleCustom
            :is_preview="true"
            class="animated fadeIn fadeOut"
            title="ドメインポリシー"
            description="デフォルトのポリシーで管理するドメイン (例: 「google.com」) を追加します"
            tooltip="ポリシーはデフォルト ポリシーでのみ構成可能で、ポリシー内のクライアントのリクエストのヘッダーのホスト フィールドに基づいて識別されます。 特定のドメインを検出またはブロックするように設定します。 例) google.com を設定するときに google.com をブロックまたは検出します。"
            :policy_list="get_origin_policy('host_list')"
          />
        </b-col>
        <b-col>
          <strong class="text-danger">Now</strong>
          <RuleCustom
            :is_preview="true"
            class="animated fadeIn fadeOut"
            title="ドメインポリシー"
            description="デフォルトのポリシーで管理するドメイン (例: 「google.com」) を追加します"
            tooltip="ポリシーはデフォルト ポリシーでのみ構成可能で、ポリシー内のクライアントのリクエストのヘッダーのホスト フィールドに基づいて識別されます。 特定のドメインを検出またはブロックするように設定します。 例) google.com を設定するときに google.com をブロックまたは検出します。"
            :policy_list="now_policy.host_list"
          />
        </b-col>
      </b-row>

      <!-- 국가 -->
      <b-row v-if="is_changed('country_code') || is_changed('use_geoip')" class="text-center mt-4">
        <b-col>
          <strong class="text-danger">Before</strong>
          <b-form-checkbox
            :checked="now_policy.use_geoip_origin"
            class="d-inline-block ml-4"
            :disabled="true"
            name="check-button"
            switch
          ></b-form-checkbox>
          <RuleCountry
            title="GEOポリシー"
            class="animated fadeIn fadeOut"
            :is_preview="true"
            tooltip="Web リクエスト クライアントの承認済み IP を国ごとに特定します。国をクリックして、検出またはブロックに設定できます。不要な国へのアクセスはブロックすることをお勧めします。"
            :agent_id="server.id"
            :use_geoip="now_policy.use_geoip_origin"
            :policy_list="get_origin_policy('country_code')"

          />
        </b-col>
        <b-col>
          <strong class="text-danger">Now</strong>
          <b-form-checkbox
            class="d-inline-block ml-4"
            :checked="now_policy.use_geoip"
            :disabled="true"
            name="check-button"
            switch
          ></b-form-checkbox>

          <RuleCountry
            title="GEOポリシー"
            class="animated fadeIn fadeOut"
            :is_preview="true"
            tooltip="Web リクエスト クライアントの承認済み IP を国ごとに特定します。国をクリックして、検出またはブロックに設定できます。不要な国へのアクセスはブロックすることをお勧めします。"
            :agent_id="server.id"
            :use_geoip="now_policy.use_geoip"
            :policy_list="now_policy.country_code"

          />
        </b-col>
      </b-row>

      <!-- 경로 / 파라미터  -->
      <b-row v-if="is_changed('path')" class="mt-4 text-center">
        <!-- 경로 설정 -->
        <b-col>
          <strong class="text-danger">Before</strong>
          <RuleCustom
            :policy_list="get_origin_policy('path')"
            is_preview="true"
            class="animated fadeIn fadeOut"
            title="パスポリシー"
            tooltip="特定のパスを使用して別のリクエストを設定します。 例) http://f1security.co.kr/manager/index.html の /manager パスをブロックすると、index.html ページも設定に従って実行されます"
          />
        </b-col>
        <b-col>
          <strong class="text-danger">Now</strong>
          <RuleCustom
            :policy_list="now_policy.path"
            is_preview="true"
            class="animated fadeIn fadeOut"
            title="パスポリシー"
            tooltip="特定のパスを使用して別のリクエストを設定します。 例) http://f1security.co.kr/manager/index.html の /manager パスをブロックすると、index.html ページも設定に従って実行されます"
          />
        </b-col>
      </b-row>

      <!-- 파라미터 설정 -->
      <b-row v-if="is_changed('parameter')" class="mt-4 text-center">
        <b-col>
          <strong class="text-danger">Before</strong>
          <RuleCustom
            :policy_list="get_origin_policy('parameter')"
            is_preview="true"
            class="animated fadeIn fadeOut mt-4"
            title="パラメータポリシー"
            tooltip="特定のパラメータを使用して別のリクエストを設定する 例) kyword=password の例のようにパスワード パラメータをブロックすると、例のようなパスワードのパラメータを含む Web リクエストが設定に従って実行されます。"
          />
        </b-col>
        <b-col>
          <strong class="text-danger">Now</strong>
          <RuleCustom
            :policy_list="now_policy.parameter"
            is_preview="true"
            class="animated fadeIn fadeOut mt-4"
            title="パラメータポリシー"
            tooltip="特定のパラメータを使用して別のリクエストを設定する 例) kyword=password の例のようにパスワード パラメータをブロックすると、例のようなパスワードのパラメータを含む Web リクエストが設定に従って実行されます。"
          />
        </b-col>
      </b-row>

      <!-- 사용자 정책 -->
      <b-row v-if="is_changed('custom_policy')" class="mt-4">
        <b-col>
          <p class="text-center">
            <strong class="text-danger">Before</strong> ユーザポリシー(CRS)
          </p>
          <textarea style="width: 100%; height: auto; max-height: 80px;" :value="base64decode(now_policy.custom_policy.trim())" :rows="crs_line_count('custom_rule')" :disabled="true"></textarea>
        </b-col>
        <b-col v-if="is_changed('custom_policy')">
          <p class="text-center">
            <strong class="text-danger">Now</strong> ユーザポリシー(CRS)
          </p>
          <textarea style="width: 100%; height: auto; max-height: 80px;" v-model="custom_policy" :rows="crs_line_count('origin_custom_rule')" :disabled="true"></textarea>
        </b-col>
      </b-row>

      <!-- 리다이렉션 설정 -->
      <b-row v-if="is_changed('redirection')" class="mt-4">
        <b-col>
          <strong class="font-weight-bold">
            <p>
              <strong class="text-danger">Before</strong> リダイレクション
            </p>
          </strong>
          <hr>
          <b-form-input :disabled="true" :state="Boolean(now_policy.redirection_origin)" placeholder="リダイレクトURLを入力してください" class="m-2" size="xl" :value="now_policy.redirection_origin"></b-form-input>
        </b-col>
        <b-col>
          <strong class="font-weight-bold">
            <p>
              <strong class="text-danger">Now</strong> リダイレクション
            </p>
          </strong>
          <hr>
          <b-form-input :disabled="true" :state="Boolean(now_policy.redirection)" placeholder="リダイレクトURLを入力してください" class="m-2" size="xl" :value="now_policy.redirection"></b-form-input>
        </b-col>
      </b-row>

      <!-- 에이전트 설정 변경 사항 -->
      <b-row v-if="is_changed('agent.setting')" class="mt-4">
        <!-- 자원 모니터링 -->
        <b-col class="text-center" v-if="agent_setting && agent_setting.limit_mode != JSON.parse(server.setting).limit_mode">
          <p style="display:inline-block; cursor: pointer;">
            <span class="mr-3">
              <strong class="text-danger">Before</strong>
              リソース監視アラート設定
            </span>
            <i v-if="agent_setting && agent_setting.limit_mode != JSON.parse(server.setting).limit_mode && JSON.parse(server.setting).limit_mode" class="fa fa-refresh fa-spin"></i>
          </p>
          <b-form-checkbox
            class="d-inline-block ml-4"
            :disabled="true"
            :checked="JSON.parse(server.setting).limit_mode"
            name="check-button"
            switch
            v-if="agent_setting && agent_setting.limit_mode != JSON.parse(server.setting).limit_mode"
          >
          </b-form-checkbox>
        </b-col>

        <b-col class="text-center text-weight-bold">
          <p style="display:inline-block; cursor: pointer;">
            <span class="mr-3">
              <strong class="text-danger">After</strong>
              リソース監視アラート設定
            </span>
            <i v-if="agent_setting && agent_setting.limit_mode != JSON.parse(server.setting).limit_mode && agent_setting.limit_mode" class="fa fa-refresh fa-spin"></i>
          </p>
          <b-form-checkbox
              class="d-inline-block ml-4"
              :disabled="true"
              :checked="agent_setting.limit_mode"
              name="check-button"
              switch
              v-if="agent_setting && agent_setting.limit_mode != JSON.parse(server.setting).limit_mode"
            >
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row v-if="is_changed('agent.setting')">
        <b-col>
          <!-- 설정 데이터 -->
          <b-row>
            <b-col sm="2" class="mt-2">CPUリミット</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input v-on:input="check_change()" :disabled="true" :number="true" type="number" placeholder="90" v-model="JSON.parse(server.setting).limit_cpu"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAMリミット</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input v-on:input="check_change()" :disabled="true" :number="true" type="number" placeholder="90" v-model="JSON.parse(server.setting).limit_ram"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Diskリミット</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input v-on:input="check_change()" :disabled="true" :number="true" type="number" placeholder="90" v-model="JSON.parse(server.setting).limit_disk"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <!-- 여기서 라인 나눔 -->
            <b-col sm="2" class="mt-2">CPUリムーブ</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input v-on:input="check_change()" :disabled="true" :number="true" type="number" v-model="JSON.parse(server.setting).resolve_cpu">
                </b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAMリムーブ</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input v-on:input="check_change()" :disabled="true" :number="true" type="number" v-model="JSON.parse(server.setting).resolve_ram">
                </b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Diskリムーブ</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input v-on:input="check_change()" :disabled="true" :number="true" type="number" v-model="JSON.parse(server.setting).resolve_disk">
                </b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <!-- 설정 데이터 -->
          <b-row v-if="is_changed('agent.setting')">
            <b-col sm="2" class="mt-2">CPU Limit</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" :number="true" type="number" placeholder="90"
                  v-model="agent_setting.limit_cpu"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAMリミット(%)</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" :number="true" type="number" placeholder="90"
                  v-model="agent_setting.limit_ram"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Diskリミット(%)</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" :number="true" type="number" placeholder="90"
                  v-model="agent_setting.limit_disk"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <!-- 여기서 라인 나눔 -->
            <b-col sm="2" class="mt-2">CPUリカバー</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" :number="true" type="number"
                  v-model="agent_setting.resolve_cpu">
                </b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAMリカバー</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" :number="true" type="number"
                  v-model="agent_setting.resolve_ram">
                </b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Diskリカバー</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" :number="true" type="number"
                  v-model="agent_setting.resolve_disk">
                </b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <!-- 제한 설정 -->
      <b-row v-if="is_changed('limit')" class="mt-4 text-center">
        <b-col>
          <strong class="text-danger">Before</strong>
          <!-- 요청 -->
          <b-row class="mt-2">
            <b-col>
              <strong class="font-weight-bold">
                リミットリクエストデータ（バイト） - ファイル転送
                <span class="text-info" v-b-tooltip.hover title="クライアントが要求するbodyデータの制限を設定します、アップロードが多様に活用されるサイトの場合、値の変更をお勧めします。">
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </strong>
            </b-col>
            <b-col>
              <b-input-group class="mt-1 mb-1">
                <b-form-input v-if="now_policy.limit_origin" :disabled="true" @change="check_change" :number="true" type="number" v-model="now_policy.limit_origin.request_body_limit"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <strong class="font-weight-bold">
                リミットリクエストデータ（バイト） - ファイル未送信
                <span class="text-info" v-b-tooltip.hover title="クライアントが要求するbodyデータの制限を設定します, ファイル転送せずに application/x-www-form-urlencoded に送信される場合に該当します">
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </strong>
            </b-col>
            <b-col>
              <b-input-group class="mt-1 mb-1">
                <b-form-input v-if="now_policy.limit_origin" :disabled="true" @change="check_change" :number="true" type="number" v-model="now_policy.limit_origin.request_body_limit_no_file"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <!-- 응답 -->
          <b-row class="text-center mt-2">
            <b-col>
              <strong class="font-weight-bold">
                応答データを制限 (Byte)
                <span class="text-info" v-b-tooltip.hover title="クライアントのリクエストに対するウェブサーバーの応答の最大データサイズを設定します。 これ以上の場合は応答しません。">
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </strong>
            </b-col>
            <b-col>
              <b-input-group class="mt-1 mb-1">
                <b-form-input v-if="now_policy.limit_origin" :disabled="true" @change="check_change" :number="true" type="number" v-model="now_policy.limit_origin.response_body_limit"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <!-- 공용 -->
          <b-row>
            <b-col class="mt-2">
              <strong class="font-weight-bold">
                コモン(リクエスト＋レスポンス)
                <span class="text-info" v-b-tooltip.hover title="WebサーバーでサポートするMIMEタイプを設定することができます。デフォルトではtext/plain、text/html、text/xmlの3つだけが有効になります。">
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </strong>
            </b-col>
          </b-row>
          <b-row class="text-center">
            <b-col class="text-center" v-if="now_policy.limit_origin && now_policy.limit_origin.mime_type">
              <multiselect
                :disabled="true"
                v-model="now_policy.limit_origin.mime_type"
                tag-placeholder="選択してください"
                placeholder="選択してください"
                :options="codes.WAF_MIME_TYPE"
                :multiple="true"
                :taggable="false"
                @input="check_change"
              >
              </multiselect>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <strong class="text-danger mt-2">Now</strong>
          <!-- 요청 -->
          <b-row class="mt-2">
            <b-col>
              <strong class="font-weight-bold">
                リミットリクエストデータ（バイト） - ファイル転送
                <span class="text-info" v-b-tooltip.hover title="クライアントが要求する本文データの制限を設定し、アップロードが広く利用されているサイトでは値を変更することを推奨します">
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </strong>
            </b-col>
            <b-col>
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" @change="check_change" :number="true" type="number" v-model="now_policy.limit.request_body_limit"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <strong class="font-weight-bold">
                リミットリクエストデータ（バイト） - ファイル未送信
                <span class="text-info" v-b-tooltip.hover title="ファイルを転送せずに application/x-ww-form-urlencoded に送信する場合、クライアントによって要求された本文データの制限を設定します">
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </strong>
            </b-col>
            <b-col>
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" @change="check_change" :number="true" type="number" v-model="now_policy.limit.request_body_limit_no_file"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <!-- 응답 -->
          <b-row class="text-center mt-2">
            <b-col>
              <strong class="font-weight-bold">
                応答データを制限 (Byte)
                <span class="text-info" v-b-tooltip.hover title="クライアントのリクエストに対してWebサーバーが応答する際の最大データサイズを設定します。これを超えると応答しません。">
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </strong>
            </b-col>
            <b-col>
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" @change="check_change" :number="true" type="number" v-model="now_policy.limit.response_body_limit"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <!-- 공용 -->
          <b-row class="mt-2">
            <b-col>
              <strong class="font-weight-bold">
                コモン(リクエスト＋レスポンス)
                <span class="text-info" v-b-tooltip.hover title="Web サーバーでサポートされる MIME のタイプを設定できます。デフォルトでは、text/plain、text/html、text/xml の 3 つだけが有効です。">
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </strong>
            </b-col>
          </b-row>
          <b-row class="text-center">
            <b-col class="text-center">
              <multiselect
                :disabled="true"
                v-model="now_policy.limit.mime_type"
                tag-placeholder="選んでください"
                placeholder="選んでください"
                :options="codes.WAF_MIME_TYPE"
                :multiple="true"
                :taggable="false"
                @input="check_change"
              >
              </multiselect>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

    </b-modal>

    <!-- TODO : 레벨 개념 활용시 추가 예정 -->
    <!-- <b-modal title="レベルカバレッジの説明" class="modal-info text-center" v-model="explain_level" ok-only
      no-close-on-backdrop ok-variant="success">
      <div class="text-center">
        <img src="img/waf_level.png" class="text-center" style="margin-left: auto; margin-right: auto;width: 90%;">
      </div>
      <hr>
      レベル4はポリシーレベル1～4で検出<br>
      レベル3はポリシーレベル1～3で検出<br>
      レベル2はポリシーレベル1～2で検出<br>
      レベル1はポリシーレベル1で検出<br>
      <hr>
      <p>
        レベルが高いほど、より多くの範囲の攻撃が検出されます。
        <br>
        レベル設定後、詳細なポリシー設定をお勧めします。
        <br>
        レベルが高いほど誤検知が発生する可能性があります。例外処理と管理が必要です。
      </p>
    </b-modal> -->

    <!-- TODO : 다른 서버로 정책 복사 기능은 2022.08 에서 지원 예정 -->
    <!-- 다른 서버에 정책 적용 모달 -->
    <!-- <b-modal hide-footer title="当該ポリシーを他のエージェントに適用" size="xl" v-model="apply_modal" header-bg-variant='warning'>
      <b-button size="sm" variant="warning" @click="policy_list = []"> クリア </b-button>
      <hr>
      <p class="m-2">
        <b-form-checkbox-group class="m-2" v-model="policy_list">
          <b-form-checkbox v-for="policy in server.policy_json.domains" :key="policy.id" :value="policy.domain">
            {{policy.domain}}
          </b-form-checkbox>
        </b-form-checkbox-group>
      </p>
      <hr v-if="apply_all_server && apply_all_server.length > 0">
      <b-badge variant="success" v-for="(item, index) in apply_all_server" :key="index" class="m-1">
        <h6 @click="multi_remove(index)" style="cursor:pointer;">{{item.nickname}} <span class="m-1"
            style="cursor:pointer;">X</span></h6>
      </b-badge>
      <hr>
      <agent-List :agent_id="server.id" :list_selected="apply_all_server" :only_select="true" @multi_clear="multi_clear"
        @multi_all="multi_all" @multi_one="multi_one"></agent-List>
      <hr>
      <b-button block variant="warning" @click="apply_confirm_modal = true" class="m-1 btn-addition">ポリシーを保存</b-button>
      <b-button block variant="info" @click="apply_modal = false" class="m-1">閉じる</b-button>
    </b-modal> -->

    <!-- 다른 서버 적용 모달 다시 확인 -->
    <!-- <b-modal hide-footer title="ポリシーへの適用を確認" size="xm" v-model="apply_confirm_modal" header-bg-variant='danger'>
      選択したエージェントに設定を適用しますか？
      <hr>
      <b-button block variant="danger" @click="multi_save" class="m-1 btn-addition">適用範囲</b-button>
      <b-button block variant="info" @click="apply_confirm_modal = false" class="m-1">閉じる</b-button>
    </b-modal> -->

    <!-- 모드 설명 모달 -->
    <b-modal title="オートスケールのサポート範囲"  class="modal-info text-center" v-model="modal_duplex" ok-only no-close-on-backdrop ok-variant="success">
      <b-badge variant="info">ご案内</b-badge> :
      <strong> Web Firewallは、以下のWebサーバーのオートスケーリングに対応しています： </strong><br>
      <hr>
      <p>
        <strong> * Active-Active : 2つ以上のサーバーの動作環境 </strong>
      </p>
      <p>
        <strong> * Active-Stanby : メインサーバー1台と、フォールトトレラントサーバー1台の運用環境 </strong>
      </p>
      <p>
        <strong> * Auto Scale Out/In : 自動スケーリングによるフローティング環境 (out/in)</strong>
      </p>
      <hr>
      <p class="text-center">
        <b-img v-bind="{ width: 300, height: 300, class: 'm1' }" src="img/multi.png" alt="Multiplexing"></b-img>
      </p>
    </b-modal>

    <!-- 방화벽 도메인 안내 모달 -->
    <b-modal hide-footer title="ドメイン管理" class="modal-info" size="xl" v-model="toggle.modal_domain_manage" no-close-on-backdrop ok-only>
      <div class="w-100 m-4 float-left">
        <img src="img/icons/conf_logo.png" width="100" alt="" style="vertical-align: top;">
        <div class="d-inline-block ml-5" style="width: 80%;">
          <span class="h4 font-weight-bold">ドメイン管理</span>
          <p class="m-2">デフォルトのポリシーとは？Webファイアウォールで使用されるデフォルトのポリシーです。ポリシーはドメイン単位で設定可能です。特定のドメインでのみポリシー設定が必要な場合は、ドメインを追加してください。</p>
          <p class="m-2">
            デフォルトポリシーを無効にする場合は、使用したいドメインを登録してください。デフォルトポリシーを無効にするには、デフォルトポリシー以外のドメインが存在する必要があります。
          </p>
        </div>
      </div>
      <hr>
      <b-table v-if="server && server.policy_json && server.policy_json.domains" ref="_list" striped hover small fixed class="table_add" :items="server.policy_json.domains" :fields="domain_manage_fields" empty-text="not found">
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template slot="domain" slot-scope="row">
          <span v-if="now_policy.domain == row.item.domain" class="d-inline-block font-weight-bold font_15">
            *
          </span>
          <b-form-input style="text-align: left;" :disabled="('default' == row.item.domain && row.index == 0) || row.item.is_save != false" class="d-inline-block m-1" size="sm" v-model="row.item.domain"></b-form-input>
          <b-badge v-if="row.item.is_save === false" class="d-inline-block" variant="danger">未保存</b-badge>
        </template>
        <template slot="button" slot-scope="row">
          <b-button size="sm" :disabled="is_add_domain_lock || row.item.temp" variant="dark" @click="domain_manage_regist('', row.item.domain)">複写</b-button>
          <!-- <b-button size="sm" :disabled="is_add_domain_lock || row.item.temp" variant="info" @click="domain_manage_regist('', row.item.domain)">修正する</b-button> -->
          <!-- TODO : 운영 모드별 설정 -->
          <!-- <b-button v-b-tooltip.hover title="準備中の機能です" :disabled="true" size="sm" variant="warning" @click="domain_direct_remove(row.item)">テストモード</b-button>
          <b-button v-b-tooltip.hover title="準備中の機能です" :disabled="true" size="sm" variant="info" @click="domain_direct_remove(row.item)">動作モード</b-button>
          <b-button v-b-tooltip.hover title="準備中の機能です" :disabled="true" size="sm" variant="primary" @click="domain_direct_remove(row.item)">ホスティング業者モード</b-button> -->

          <b-button :disabled="is_add_domain_lock" v-if="row.item.domain != 'default'" size="sm" variant="outline-danger" @click="domain_manage_remove(row.item.domain)">削除</b-button>

          <!-- 다른 도메인이 있을 경우 비활성화 가능 -->
          <!-- defalut -->
          <div class="checkbox-switch mr-1 ml-1" v-b-tooltip.hover title="追加の場合、デフォルトポリシーの非アクティブ化が可能です" style="vertical-align: middle;">
            <input type="checkbox" class="input-checkbox" name="default" v-model="row.item.is_alive" :disabled="row.item.domain == 'default' && server.policy_json.domains.length < 2">
            <div class="checkbox-animate" :class="{ disabled : row.item.domain == 'default' && server.policy_json.domains.length < 2 }">
                <span class="checkbox-off">Off</span>
                <span class="checkbox-on">On</span>
            </div>
          </div>
        </template>
      </b-table>
      <hr>
      <b-row class="text-center">
        <b-col>
          <span v-if="!auth.license.onPremise && false" class="float-left font-weight-bold text-danger">チャージ時、サブドメインは1つのドメインに分割されます</span>
          <b-form-input :disabled="is_add_domain_lock" class="d-inline-block m-1" size="sm" v-model="new_domain" @keyup.native.enter="domain_manage_regist(new_domain)" placeholder="ドメイン追加 Enter" style="width: 70%;"></b-form-input>
          <b-button :disabled="is_add_domain_lock" class="btn-addition d-inline-block m-1" size="sm" variant="success" @click="domain_manage_regist(new_domain)">追加</b-button>
          <b-button class="d-inline-block m-1" size="sm" @click="toggle.modal_domain_manage = false">閉じる</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <!-- 도메인 삭제 모달 -->
    <b-modal title="ドメインの削除" class="modal-danger" v-model="modal_domain_remove" no-close-on-backdrop @ok="domain_manage_remove()" header-bg-variant="danger">
      既存のドメインを削除した場合、タスクは一緒に保存されます
      既存のドメイン設定は削除されます
      本当に削除してよろしいでしょうか？
    </b-modal>

    <!-- 정책 버전 업데이트 모달 -->
    <b-modal title="ポリシーの基本バージョンの変更" class="modal-warning text-center" v-model="change_main_policy" no-close-on-backdrop ok-variant="success" hide-footer>
      <b-badge variant="warning">お知らせ</b-badge>
      <strong> ファイアウォールポリシーを変更 </strong>
      <hr>
      <p>ポリシーバージョン [ {{crs_rule.version}} ] => <span class="font-weight-bold text-danger">[ {{target_crs_rule.version}}
          ]</span> </p>
      <hr>
      <p>必要最小限のエージェントバージョン [ {{crs_rule.agent_version ? crs_rule.agent_version : '-'}} ] => <span
          class="font-weight-bold text-danger">[ {{target_crs_rule.agent_version ? target_crs_rule.agent_version : '-'}}
          ]</span> </p>
      <hr>
      <p class="text-danger">* 基本ポリシーを変更するとページが更新されます</p>
      <hr>
      <small class="font-weight-bold">* ポリシーを変更した後問題が発生した場合、ポリシーを再度復元することができます</small>
      <hr>
      <div class="modal-footer">
        <!-- <b-button block class="btn btn-success" @click="change_crs">更新情報</b-button> -->
        <b-button block class="btn btn-light" @click="change_main_policy = false; target_crs_rule = crs_rule;">キャンセル</b-button>
      </div>
    </b-modal>

    <!-- 이름 변경 모달 -->
    <b-modal title="サーバー名の変更" class="modal-warning text-center" v-model="name_modify_modal" no-close-on-backdrop
      ok-variant="success" hide-footer header-bg-variant="info">
      <p> サーバーの名前を変更することができます。 </p>
      <p> 変更したい名称を入力します。初期のサーバー名は、サーバーのホスト名です。 </p>
      <p> <b> * サーバー名の解決 </b> </p>
      <p> 変更前のサーバー名 : {{server.nickname}} </p>
      <b-form-input v-model="modify_name" placeholder="変更したい名前を入力してください"></b-form-input>

      <div class="modal-footer">
        <b-button block class="btn btn-success" @click="name_modify()">保存</b-button>
        <b-button block class="btn btn-light" @click="name_modify_modal = false">キャンセル</b-button>
      </div>
    </b-modal>

    <!-- 로그 상세 모달 -->
    <b-modal size="xl" class="modal-warning text-center" v-model="toggle.modal_log" no-close-on-backdrop ok-variant="success"
      hide-footer header-bg-variant="info">
      <LogDetail :id="modal_log_id" @reload="get()" @policy_id="(value) => { toggle.modal_log = false; search_key = value; }" :only_view="false" />
    </b-modal>

    <!-- 적용 실패 안내 -->
    <b-modal :title="webcastle_alert_is_error ? 'エラー通知' : '正常に保存されました'" size="ml"
      :class="`modal-${webcastle_alert_is_error ? 'danger' : 'success'} text-center`" v-model="webcastle_alert"
      no-close-on-backdrop :ok-variant="webcastle_alert_is_error ? 'danger' : 'success'" ok-only
      :header-bg-variant="webcastle_alert_is_error ? 'danger' : 'success'">
      <h4 v-if="webcastle_alert_is_error" class="text-danger font-weight-bold">変更したポリシーの適用に問題がありました</h4>
      <h4 v-if="webcastle_alert_is_error" class="text-danger font-weight-bold">Web Firewallの障害発生時に、以前の設定に戻す必要があります</h4>
      <h4 v-else class="font-weight-bold"></h4>
      <hr>
      <p>
        msg : {{ webcastle_alert_msg || '-' }}
      </p>
      <br>
    </b-modal>

    <!-- 설정 업로드 모달 -->
    <b-modal title="アップロードポリシー" size="ml" class="modal-info" v-model="modal_upload_policy" no-close-on-backdrop ok-variant="success" ok-only header-bg-variant="success" @ok="upload_policy_save">
      <b-form-file
        :state="Boolean(upload_policy_file)"
        placeholder="ポリシー JSON ファイルをアップロードしてください"
        drop-placeholder="ポリシー JSON ファイルをアップロードしてください"
        @change="upload_policy_change"
      ></b-form-file>
      <hr v-if="upload_policy_data">
      <b-form-checkbox class="d-block m-2" v-for="(item, index) in upload_policy_data.domains" v-model="upload_policy_selected" :key="item.domain" :value="item.domain">
          {{item.domain}}
        </b-form-checkbox>
      <hr>
      <span class="text-danger">* 一致するドメイン設定は上書きされ、存在しないポリシーは作成されます</span>
      <br>
      <span class="text-danger">* ポリシーファイルが正確でない場合、アップロードに失敗することがあります</span>
      <br>
      <span class="text-danger">* アップロードされたポリシーをご確認の上、保存してください</span>
    </b-modal>

    <!-- 서버 삭제 안내 모달 -->
    <b-modal title="エージェントに削除" class="modal-danger" v-model="toggle.modal_del" @ok="remove" @cancel="del_nickname = '';" header-bg-variant="danger" ok-variant="danger">
      <p> ここからエージェントを削除しても、サーバーから自動的に削除されるわけではありません。先にサーバーから削除しておくことをお勧めします</p>
      <p> 削除された場合は、ファイアウォールの役割を実行しないようにします</p>
      <p> <b> * サーバー名を解決 </b> </p>
      <p> サーバー名を解決 : {{server.nickname}} </p>
      <b-form-input v-model="del_nickname" placeholder="削除するサーバーの名前を入力します"></b-form-input>
    </b-modal>

    <!-- 정책 업그레이드 모달 -->
    <b-modal title="アップグレードポリシー" class="modal-danger text-center" v-model="upgrade_policy_modal" no-close-on-backdrop
      ok-variant="success" hide-footer header-bg-variant="info">
      <p> 近日公開 </p>
      <!-- <p> 変更する名前を記入してください。初期サーバー名はサーバーのホスト名です。 </p>
      <p> <b> * サーバー名の確認 </b> </p>
      <p> 変更前のサーバー名 : {{server.nickname}} </p>
      <b-form-input v-model="modify_name" placeholder="変更する名前を入力してください"></b-form-input> -->

      <div class="modal-footer">
        <!-- <b-button block class="btn btn-success" @click="name_modify()">適用範囲</b-button> -->
        <b-button block class="btn btn-light" @click="upgrade_policy_modal = false">キャンセル</b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
